import React, { Fragment, useEffect, useState } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Image } from '../AbstractElements';
import { fetchAdmins } from '../firebase/utils';
import ResetPassword from './ResetPassword';
import imgg from '../assets/images/logo/expUniversityBlack.png';
import Loader from '../Layout/Loader';

const PasswordReset = () => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  let urlOrigin;
  try {
    const url = new URL(window.location.href);
    urlOrigin = url.origin;
  } catch (error) {
    toast.error("Unable to get URL Origin");
    navigate('/login');
  }

  const redirectUrl = "https://portal.expertizouniversity.pk/email-handler";

  let mode;
  let code;
  let emailParam;
  let condition;
  
  const getAdminsAndCheck = async () => {
    if (condition) return;
    try {
      setLoading(true);
      const admins = await fetchAdmins();
      const isEmailAdmin = admins.some(admin => admin.email === emailParam);
      if (!isEmailAdmin) {
        navigate('/login');
        toast.error("You are not authorized to reset your password");
      } else {
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      toast.error(error.message);
      setLoading(false);
    }
  }

  const navigateToStudentPortal = (args) => {
    const { continueUrl, urlParams } = args;
    if (continueUrl) urlParams.delete("continueUrl");

    const newUrl = `${redirectUrl}?${urlParams.toString()}`;
    window.location.href = newUrl;
    return null;
  };

  useEffect(() => {
    getAdminsAndCheck();
  }, []);

  const urlParams = new URLSearchParams(window.location.search);
  mode = urlParams.get("mode");
  code = urlParams.get("oobCode");
  condition = !mode || !code;

  const continueUrl = urlParams?.get("continueUrl");

  const args = { continueUrl, urlParams };

  if (condition && continueUrl) {
    toast.error("Invalid mode or code");
    navigate("/login");
    return null;
  }

  if (!continueUrl) {
    navigateToStudentPortal(args);
    return null;
  }

  if (mode !== "resetPassword") {
    toast.error("Invalid mode");
    navigate("/login");
    return null;
  }

  if (!continueUrl.startsWith(urlOrigin)) {
    toast.error("Invalid continue URL");
    navigate("/login");
    return null;
  }

  emailParam = new URL(continueUrl).searchParams.get("email") || "";

  const renderComponentByType = () => {
    switch (mode) {
      case "resetPassword":
        return <ResetPassword oobCode={code} emailParam={emailParam} parentLoading={loading} />
      default:
        return null;
    }
  };

  if (loading) return <Loader />;

  return (
    <Fragment>
      <Container fluid={true} className="p-0">
        <Row className='mx-0'>
          <Col xs="12" className='px-0'>
            <div className="login-card auth-login">
              <div>
                <Link className="logo" to={`${process.env.PUBLIC_URL}/dashboard`}>
                  <Image attrImage={{ src: `${imgg}`, alt: '', className: "app-logo" }} />
                </Link>
              </div>
              <div className="login-main1 login-tab1 login-main">
                {renderComponentByType()}
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
}

export default PasswordReset;